// need to add scan functionality and link it to Scan Badge button - should automatically scan the badge
// maybe implement log to prevent double scans?
// todo logic to check if meal has already been used + mark as used
// might need to clean up the overlay screen

// need to check hacker has checked in

// convert from hacker to judge

import React, { useState, useEffect } from 'react';
import { X, Check, User, Utensils, UtensilsCrossed } from 'lucide-react';

import ScanBadgeButton from '../../../components/scan-badge-button/scan-badge-button';

import { fetchUserRecord } from '../../../utils/mongoDataOperations';
import { getMeal } from '../../../utils/helpers';

const Meals = () => {
  const [scannedReturnedID, setScannedReturnedID] = useState(null);
  const [scannedUserRecord, setScannedUserRecord] = useState(null);
  const [alreadyUsed, setAlreadyUsed] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (scannedReturnedID) {
        try {
          const response = await fetchUserRecord(scannedReturnedID);
          setScannedUserRecord(response);
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
    };
    fetchData();
  }, [scannedReturnedID]);

  // Reset alreadyUsed when scannedReturnedID changes
  useEffect(() => {
    setAlreadyUsed(null);
  }, [scannedReturnedID]);

  const InfoItem = ({ icon: Icon, label, value }) => (
    <div className='flex items-center mb-4 space-x-3'>
      <div className='bg-gray-100 flex h-8 items-center justify-center rounded-full w-8'>
        <Icon className='h-4 text-gray-600 w-4' />
      </div>
      <div>
        <p className='text-gray-500 text-sm'>{label}</p>
        <p className='font-medium'>{value || '...'}</p>
      </div>
    </div>
  );

  return (
    <div className='max-w-4xl mx-auto p-6 space-y-6'>
      {/* Scan Controls */}
      <div className='flex justify-end space-x-3'>
        <button
          onClick={() => {
            setScannedUserRecord(null);
            setScannedReturnedID(null);
          }}
          className='border border-gray-300 hover:bg-gray-50 inline-flex items-center px-4 py-2 rounded-lg text-gray-700 transition-colors'>
          Clear
        </button>
        <ScanBadgeButton
          scannedReturnedID={scannedReturnedID}
          setScannedReturnedID={setScannedReturnedID}
        />
      </div>

      {/* Header with Active Meal */}
      <div className='bg-white p-6 rounded-lg shadow text-center'>
        <div className='flex items-center justify-center mb-2'>
          <Utensils className='h-6 mr-2 text-tree-green w-6' />
          <h2 className='font-semibold text-2xl'>Active Meal</h2>
        </div>
        <p className='text-xl'>
          {getMeal() === null
            ? 'No meals currently active'
            : `${new Date().toLocaleString('en-us', {
                weekday: 'long',
              })} ${getMeal()}`}
        </p>
      </div>

      {/* Hacker Information */}
      {scannedUserRecord?.application_info && (
        <div className='bg-white p-6 rounded-lg shadow'>
          <h2 className='font-semibold mb-4 text-xl'>Hacker Information</h2>
          <InfoItem
            icon={User}
            label='Full Name'
            value={scannedUserRecord?.application_info?.full_name}
          />
          <InfoItem
            icon={User}
            label='Gender'
            value={scannedUserRecord?.application_info?.gender}
          />
          <InfoItem
            icon={UtensilsCrossed}
            label='Dietary Restrictions'
            value={scannedUserRecord?.meal_info?.dietaryRestrictions || '...'}
          />
        </div>
      )}

      {/* Status Screens */}
      {alreadyUsed === true && (
        <div className='bg-opacity-90 bg-red-500 fixed flex inset-0 items-center justify-center p-6 z-50'>
          <div className='text-center text-white'>
            <X className='h-24 mb-6 mx-auto w-24' />
            <h2 className='font-bold mb-2 text-3xl'>Meal Already Used</h2>
            <p className='opacity-90 text-xl'>
              This meal has already been claimed
            </p>
          </div>
        </div>
      )}

      {alreadyUsed === false && (
        <div className='bg-green-500 bg-opacity-90 fixed flex inset-0 items-center justify-center p-6 z-50'>
          <div className='text-center text-white'>
            <Check className='h-24 mb-6 mx-auto w-24' />
            <h2 className='font-bold mb-2 text-3xl'>Meal Approved</h2>
            <p className='mb-4 text-xl'>
              Hacker is clear to receive their meal
            </p>
            {scannedUserRecord?.meal_info?.dietaryRestrictions && (
              <div className='bg-white inline-block px-4 py-2 rounded-lg text-green-700'>
                <p className='font-medium'>
                  Dietary Restrictions:{' '}
                  {scannedUserRecord?.meal_info?.dietaryRestrictions}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Meals;
